// Admin Test Ads mode.
//
// When enabled, all AdMob calls use Google's official test ad unit IDs and
// every frequency cap / paid-user gate is bypassed — so an admin can verify
// every ad placement on a real device before the production IDs are wired up.
//
// State is mirrored to localStorage so synchronous getters in native-ads.ts
// and the various gate components can read it without React.

const STORAGE_KEY = "fitaura.adminTestAds";

let cached: boolean | null = null;

function read(): boolean {
  if (cached !== null) return cached;
  try {
    cached = typeof localStorage !== "undefined"
      && localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    cached = false;
  }
  return cached!;
}

/** Synchronous: safe to call from anywhere (no React needed). */
export function isAdminTestAds(): boolean {
  return read();
}

export function setAdminTestAds(on: boolean): void {
  cached = on;
  try {
    localStorage.setItem(STORAGE_KEY, on ? "1" : "0");
    // Notify same-tab listeners (Profile toggle ↔ banner/gate hooks).
    window.dispatchEvent(new CustomEvent("fitaura:adminTestAds", { detail: on }));
  } catch {
    /* ignore */
  }
}

/** Hook helper — subscribe to changes (same-tab) and read current value. */
export function subscribeAdminTestAds(cb: (on: boolean) => void): () => void {
  const handler = (e: Event) => cb((e as CustomEvent<boolean>).detail);
  window.addEventListener("fitaura:adminTestAds", handler);
  return () => window.removeEventListener("fitaura:adminTestAds", handler);
}
